<nz-layout class="background-container">
    <nz-content>
        <div class="containerInner">
          <div>
            <router-outlet #outlet="outlet"></router-outlet>
          </div>
        </div>
    </nz-content>
  </nz-layout>